import { render, staticRenderFns } from "./benchmark.vue?vue&type=template&id=a286686c&"
import script from "./benchmark.vue?vue&type=script&lang=js&"
export * from "./benchmark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports